import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IAlarm } from '@obvious.tech/constellation'

export const Alarm = defineEntity('Alarm', {
  endpoint: 'alarms/api/Alarm',
  schema: SNoop<IAlarm>(),
})
